import styled from 'styled-components'

export const customCardStyles = {
  Card: styled.div`
    min-width: 275px;
  `
}
